// @ts-nocheck
import { defaults } from 'lodash';

import { DEFAULT_LOCALE } from '@/constants';

const generateActiveMessages = (locale, translations) =>
    defaults(translations[locale] || translations[DEFAULT_LOCALE], translations[DEFAULT_LOCALE]);

export default generateActiveMessages;
